import { FC } from 'react';

import { CategoryContentProps } from './types';
import { TrackedPhoneNumber } from '@/components/TrackedPhoneNumber';

const Content: FC<CategoryContentProps> = ({ location }) => (
  <>
    <h2>
      {`CallAPro${location}: 24/7 Same-Day Estimates, Service & Repair - `}
      <TrackedPhoneNumber />
    </h2>
    <section>
      <h3>{"CallAPro's plumbers can handle any plumbing service, including:"}</h3>
      <ul>
        <li>Clogged Drains</li>
        <li>Faucets &amp; Fixtures</li>
        <li>Frozen Pipes</li>
        <li>Gas Lines</li>
        <li>Garbage Disposals</li>
        <li>Hot Water Heaters</li>
        <li>Hydro Jetting</li>
        <li>Pipes &amp; Re-Piping</li>
        <li>Plumbing Leaks</li>
        <li>Sewers &amp; Drains</li>
        <li>Sinks</li>
        <li>Sump Pumps</li>
        <li>Toilets</li>
        <li>Water Filtration</li>
        <li>Water Lines</li>
        <li>Water Softeners</li>
        <li>Well Pumps</li>
        <li>Showers &amp; Tubs</li>
      </ul>
    </section>
    <section>
      <h3>No job is too big or too small.</h3>
      <p>
        {'CallAPro ${location} handles any job. Whether you need a repair, installation or replacement, contact CallAPro today at '}
        <TrackedPhoneNumber />
        {' for 24/7 same-day service and a no-obligation quote.'}
      </p>
    </section>
    <section>
      <h3>{`Why Call CallAPro${location}?`}</h3>
      <p>Commitment to quality, reasonable prices and attention to detail.</p>
      <ul>
        <li>Same-Day, 24-Hour Service</li>
        <li>Always Fast, On-Time Arrival</li>
        <li>Certified &amp; Licensed Contractors</li>
        <li>Risk-Free, Up-Front Estimates</li>
        <li>Transparent, Affordable Pricing</li>
      </ul>
    </section>
    <section>
      <h3>Fast and Reliable</h3>
      <p>
        {"When you need quick and reliable plumbing services, all you have to do is pick up the phone, we'll do the rest. Contact us today at "}
        <TrackedPhoneNumber />
        {' to schedule your appointment.'}
      </p>
    </section>
  </>
);

export default Content;
